// Wrapper to make testing easier
import * as markedModule from 'marked';

export const marked = markedModule.marked;
export const Renderer = markedModule.Renderer;
